import { Typography, Box } from '@mui/material';
import { FC, useRef, useState, useEffect } from 'react';
import { TooltipComponent } from '../../../atomic/feedback';

export const BenefitSetNameCell: FC<{ name: string }> = ({ name }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setShowTooltip(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [name]);

  const benefitSetName = (
    <Typography ref={textRef} className="font-medium truncate w-full">
      {name}
    </Typography>
  );

  return (
    <Box className="flex items-center max-w-[230px] min-w-[200px]">
      {showTooltip ? (
        <TooltipComponent arrow title={name}>
          {benefitSetName}
        </TooltipComponent>
      ) : (
        benefitSetName
      )}
    </Box>
  );
};
